import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import Navbar from "@/components/Navbar";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      navigate("/account");
    } catch (err: any) {
      setError(err.message || "Login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <Navbar />
      <main className="min-h-[80vh] bg-[#0b111c] flex items-center justify-center px-6 py-16">
        <form
          onSubmit={onSubmit}
          className="w-full max-w-md space-y-5 rounded-2xl bg-[#11192b] p-8 border border-sky-500/20"
        >
          <h1 className="text-3xl font-black text-white">Sign in</h1>
          {error && <p className="rounded-lg bg-red-500/10 text-red-400 px-4 py-3 text-sm">{error}</p>}
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full rounded-xl bg-[#0b111c] p-4 text-white border border-sky-500/20"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full rounded-xl bg-[#0b111c] p-4 text-white border border-sky-500/20"
          />
          <button
            disabled={busy}
            className="w-full rounded-xl bg-sky-500 py-4 text-lg font-bold text-white hover:bg-sky-400 transition disabled:opacity-60"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
          <p className="text-center text-gray-400 text-sm">
            No account?{" "}
            <Link to="/register" className="text-sky-400 hover:underline">
              Create one
            </Link>
          </p>
        </form>
      </main>
    </>
  );
}
